import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBanners } from '../../actions/userActions';
import '../layouts/Header.css';
import Nav from './nav';
import FeaturedCategories from './FeaturedCategories';

export default function Slideshow() {
  const dispatch = useDispatch();

  const {
    banners = [],
    isAuthenticated,
    loading,
  } = useSelector(state => state.authState);

  // 🔥 FIX: run when auth finishes loading
  useEffect(() => {
    if (!loading) {
      dispatch(getBanners());
    }
  }, [dispatch, loading, isAuthenticated]);

  return (
    <>
      <div className="container-fluid carousel-pad">
        <div
          id="carouselExample"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
          data-bs-interval="3000"
          data-bs-pause="false"
        >
          <div className="carousel-inner" style={{ borderRadius: '10px' }}>
            {banners &&
              banners.map((banner, index) => (
                <div
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}
                  key={index}
                >
                  <img
                    src={banner.url}
                    className="d-block w-100"
                    alt={`Slide ${index + 1}`}
                    style={{ pointerEvents: 'none', userSelect: 'none' }}
                    onContextMenu={e => e.preventDefault()}
                  />
                </div>
              ))}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="prev"
          >
            <span className="custom-arrow-icon">&#8592;</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="next"
          >
            <span className="custom-arrow-icon">&#8594;</span>
          </button>
        </div>
      </div>

      <Nav />
      <FeaturedCategories />
    </>
  );
}